import { ProductProps } from '@components/tickets/StoresSaleProductList'
import {
  Maybe,
  StoresTicketSalesPageLayoutFragment,
  TicketReleasesPanelFragment,
} from '@ts/operations'
import React from 'react'

import StoresOffersTable from '../offers/StoresOffersTable'

export type StoresTicketSalesPageProps = {
  benefitsList?: StoresTicketSalesPageLayoutFragment['benefitsList'] | null
  country: string
  currencySymbol: Maybe<string>
  products: ProductProps[]
  releasePhaseStepperProductId: string
  ticketReleasesPanel: Maybe<TicketReleasesPanelFragment>
}

const StoresTicketSalesPage = ({
  benefitsList,
  currencySymbol,
  country,
  products,
  ticketReleasesPanel,
}: Partial<StoresTicketSalesPageProps>) => {
  const displayPriceIncludingTax = ticketReleasesPanel?.displayPriceIncludingTax

  return products && products.length > 0 ? (
    <StoresOffersTable
      benefitsList={benefitsList}
      country={country || ''}
      currencySymbol={currencySymbol || ''}
      displayPriceIncludingTax={displayPriceIncludingTax || undefined}
      products={products}
    />
  ) : null
}

export default StoresTicketSalesPage
